module.exports = __webpack_public_path__ + "img/logopk1.7a564c26.png";